import { unitCount } from '@/lib/sources/scopeSelection';
import type { ScopePicker } from './useScopePicker';

/** The picker footer's running total: size, pages it will use this month,
 *  and why it can't be sent yet. */
export function ScopeSummary({ picker }: { picker: ScopePicker }) {
  const { unit, limit, pagesLeft, selectedUnits, estPages } = picker;
  if (selectedUnits === 0) {
    return (
      <span className='text-[13px] text-muted-foreground'>
        Choose at least one part to continue
      </span>
    );
  }
  return (
    <span className='flex flex-wrap items-center gap-2 text-[13px] tabular-nums text-muted-foreground'>
      <span>
        <span className='font-semibold text-foreground'>
          {unitCount(unit, selectedUnits)}
        </span>
        {limit !== null && <> of {limit.toLocaleString()} allowed per file</>}
        {/* Sheets and videos are not chosen in pages: say what they cost.
            (A video's transcript counts 1,000 words a page.) */}
        {(unit === 'cell' || (unit === 'minute' && estPages > 0)) && (
          <> · about {unitCount('page', estPages)}</>
        )}
        {pagesLeft !== null && (
          <> · {pagesLeft.toLocaleString()} pages left this month</>
        )}
      </span>
      {picker.overFile && (
        <span className='rounded-full border border-destructive/50 px-2 py-0.5 text-xs font-semibold text-destructive'>
          over the per-file limit
        </span>
      )}
      {!picker.overFile && picker.overMonth && (
        <span className='rounded-full border border-destructive/50 px-2 py-0.5 text-xs font-semibold text-destructive'>
          more than you have left this month
        </span>
      )}
    </span>
  );
}
